import React from 'react';
import { FaGripVertical } from 'react-icons/fa';
import { FiX } from 'react-icons/fi';
import styles from './WidgetWrapper.module.scss';

type Props = {
	isEditMode: boolean;
	onRemove?: () => void;
	children: React.ReactNode;
};

const WidgetWrapper = ({ isEditMode, onRemove, children }: Props) => {
	return (
		<div className={`${styles.wrapper} ${isEditMode ? styles.editMode : ''}`}>
			<div className={`${styles.dragHandle} widget-drag-handle`}>
				<FaGripVertical className={styles.dragIcon} />
			</div>
			{onRemove && (
				<button
					className={styles.removeButton}
					onClick={e => { e.stopPropagation(); onRemove(); }}
				>
					<FiX />
				</button>
			)}
			<div className={styles.content}>
				{children}
			</div>
		</div>
	);
};

export default WidgetWrapper;
